export default __webpack_public_path__ + "static/media/astro-man.d3a7e716.png";